import axios from 'axios';

import { API_ENDPOINTS } from '../config/apiConfig';
import { StripeTipPaymentOption } from '../types';

export const STRIPE_PAYMENT_METHOD_TYPES_BY_OPTION: Record<StripeTipPaymentOption, string[]> = {
  card: ['card'],
  cash_app: ['cashapp'],
};

export interface CreateStripeTipCheckoutSessionPayload {
  amount: number;
  appointmentId: string;
  companyName: string;
  coverProcessingFee: boolean;
  currency?: 'usd';
  customerName?: string;
  paymentOption: StripeTipPaymentOption;
  processingFee: number;
  returnUrl: string;
  technicianTip: number;
  total: number;
}

export interface StripeTipCheckoutSessionResponse {
  checkoutUrl?: string;
  sessionId?: string;
  url?: string;
}

export async function createStripeTipCheckoutSession(
  payload: CreateStripeTipCheckoutSessionPayload
): Promise<StripeTipCheckoutSessionResponse> {
  const amountCents = Math.round(payload.total * 100);
  const selectedAmountCents = Math.round(payload.amount * 100);
  const processingFeeCents = Math.round(payload.processingFee * 100);
  const technicianTipCents = Math.round(payload.technicianTip * 100);

  const response = await axios.post<StripeTipCheckoutSessionResponse>(
    API_ENDPOINTS.PAYMENT.STRIPE_TIP_CHECKOUT_SESSION(),
    {
      ...payload,
      amountCents,
      selectedAmountCents,
      currency: payload.currency ?? 'usd',
      processingFeeCents,
      stripePaymentMethodTypes: STRIPE_PAYMENT_METHOD_TYPES_BY_OPTION[payload.paymentOption],
      technicianTipCents,
    }
  );

  return response.data;
}
